<template>
    <div>
        <div class="page">
            <div class="top-notice">应付金额</div>
            <div class="top-value">¥{{price}}</div>
            <van-row class="info-item" type="flex" justify="space-between" align="center" >
                <van-col class="info-name">付款方式</van-col>
                <van-col>
                    <van-row type="flex" justify="space-between" align="center">
                        <van-col >
                            <img src="../assets/pay_weixin.png" class="icon-pay"/>
                        </van-col>
                    </van-row>
                </van-col>
            </van-row>
            <div>{{error}}</div>
            <!--<van-row class="info-item" type="flex" justify="space-between" align="center">-->
                <!--<van-col class="info-name">优惠券</van-col>-->
                <!--<van-col>-->
                    <!--<van-row type="flex" justify="space-between" align="center" @click="chooseYouhui">-->
                        <!--<van-col class="info-value">{{youhuiName}}</van-col>-->
                        <!--<van-col >-->
                            <!--<img src="../assets/icon_right.png" class="icon-right"/>-->
                        <!--</van-col>-->
                    <!--</van-row>-->
                <!--</van-col>-->
            <!--</van-row>-->
            <!--<van-row class="info-item" type="flex" justify="space-between" align="center">-->
                <!--<van-col class="info-name">积分</van-col>-->
                <!--<van-col>-->
                    <!--<van-row type="flex" justify="space-between" align="center">-->
                        <!--<van-col class="info-value">235</van-col>-->
                        <!--<van-col >-->
                            <!--<img src="../assets/icon_right.png" class="icon-right"/>-->
                        <!--</van-col>-->
                    <!--</van-row>-->
                <!--</van-col>-->
            <!--</van-row>-->


        </div>
        <div class="action-area">
            <div class="action" @click="gotopay">立即付款</div>
        </div>
    </div>

</template>

<script>
import { orderPay, getWxConfig } from "@/api/api";

import wx from "weixin-js-sdk";
export default {
  name: "pay-info",
  data() {
    return {
      youhuiName: "4张可用",
      orderNum: this.$route.query.ordernum,
      price: this.$route.query.price,
      error: "",
    };
  },
  methods: {
    chooseYouhui() {
      this.$router.push({ path: "/youhuiquan" });
    },

    gotopay() {
      let params = {
        orderNum: this.orderNum,
      };
      const _this = this;
      orderPay(params).then((res) => {
        if (res.code == 0) {
          wx.chooseWXPay({
            timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
            package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: res.data.paySign, // 支付签名
            success: function(res) {
              // 支付成功后的回调函数
              _this.$router.replace({ path: "/myorder" });
            },
          });
          // WeixinJSBridge.invoke(
          //     'getBrandWCPayRequest',
          //     {
          //         "appId": res.data.appId,
          //         "nonceStr": res.data.nonceStr,
          //         "package": res.data.package,
          //         "signType": res.data.signType,
          //         "timeStamp": res.data.timeStamp,
          //         "paySign": res.data.paySign
          //     },
          //     function(res){
          //         if(res.err_msg == "get_brand_wcpay_request:ok" ) {
          //         // 使用以上方式判断前端返回,微信团队郑重提示：
          //         // res.err_msg将在用户支付成功后返回
          //         // ok，但并不保证它绝对可靠。
          //         }
          //     }
          // );
        }
      });
    },
    getWxInfo() {
      var jumpUrl = encodeURIComponent(window.location.href);
      let params = {
        url: jumpUrl,
      };
      getWxConfig(params).then((res) => {
        if (res.code == 0) {
          this.doWexinConfig(res.data);
        }
      });
    },
    doWexinConfig(info) {
      let that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: info.appId, // 必填，公众号的唯一标识
        timestamp: info.timestamp + "", // 必填，生成签名的时间戳
        nonceStr: info.noncestr, // 必填，生成签名的随机串
        signature: info.signature, // 必填，签名
        jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
      });

      wx.ready(() => {
        console.log("wx.ready");
        that.code = that.code + "微信jssdk调用成功";
      });

      wx.error(function(res) {
        console.log("wx err", res);
        that.code = that.code + "微信jssdk调用失败" + JSON.stringify(res);

        //可以更新签名
      });
    },
  },
  mounted() {
    if (
      localStorage.getItem("youhui") &&
      localStorage.getItem("youhui") !== null
    ) {
      console.log(localStorage.getItem("youhui"));
      this.youhuiName = "优惠¥" + localStorage.getItem("youhui");
    }
    this.getWxInfo();
  },
};
</script>

<style scoped>
.page {
  margin-right: 16px;
  margin-left: 16px;
}
.top-notice {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 158, 168, 1);
  line-height: 17px;
  text-align: center;
  margin-top: 37px;
}
.top-value {
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 129, 80, 1);
  line-height: 56px;
  text-align: center;
  margin-top: 4px;
  margin-bottom: 40px;
}
.info-item {
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #dfdfdf;
}
.info-name {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.info-value {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.icon-right {
  width: 6px;
  height: 12px;
  margin-left: 12px;
  display: block;
}
.icon-pay {
  width: 85px;
  height: 25px;
}
.action-area {
  position: absolute;
  bottom: 24px;
  width: 100%;
}
.action {
  width: 201px;
  height: 48px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 25px;
  font-size: 17px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  margin: 0 auto;
  text-align: center;
}
</style>
